import React from 'react'
import styled from 'styled-components'
import NavLink, { NavLinkProps } from './nav-link'
import { desktop, mobile } from '../../utils/media-query'

type NavLinksProps = {
    titles: NavLinkProps[]
}

const Container = styled.div`
    display: flex;

    ${props =>
        !props.theme.disableMobileQueries
            ? mobile.css`
        flex-direction: column;
        justify-content: space-evenly;
        align-items: center;
        background: none;
        height: 100%;
        font-size: 25px;
        font-weight: bold;
        opacity: 0.3;
    `
            : ''}
    ${props =>
        !props.theme.disableMobileQueries
            ? desktop.css`
        justify-content: flex-end;
        color: white;
        font-size: 16px;
        flex: 2;
        margin: 0 20px;
        height: 100%;
    `
            : `
        justify-content: flex-end;
        color: white;
        font-size: 16px;
        flex: 2;
        margin: 0 20px;
        height: 100%;
    `}
`

const NavLinks = ({ titles }: NavLinksProps) => {
    return (
        <Container>
            {titles.map(({ item, hasDropdown }, index) => (
                <NavLink key={index} item={item} hasDropdown={hasDropdown} />
            ))}
        </Container>
    )
}

export default NavLinks
